import { render, staticRenderFns } from "./TianMap.vue?vue&type=template&id=3ab54662&scoped=true"
import script from "./TianMap.vue?vue&type=script&lang=js"
export * from "./TianMap.vue?vue&type=script&lang=js"
import style0 from "./TianMap.vue?vue&type=style&index=0&id=3ab54662&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab54662",
  null
  
)

export default component.exports